import graphqlClient from '@/graphql/graphql-client';
import { toScalarListVariables } from '@/graphql/list-query';
import type { ListQueryVariables } from '@/graphql/types';
import { useQuery } from '@tanstack/react-query';

import {
  TemplateFieldssDocument,
  type TemplateFieldssQuery,
} from '@/graphql/generated/graphql';

export type TemplateFieldRecord = NonNullable<
  NonNullable<TemplateFieldssQuery['getTemplateFieldss']>['items']
>[number];
export type GetTemplateFieldsResponse = TemplateFieldssQuery;

export const useGetTemplateFields = (params?: ListQueryVariables<Record<string, unknown>>) => {
  const variables = toScalarListVariables(params, { screenId: 'ScreenId' });
  return useQuery({
    queryKey: ['template-fields', variables],
    queryFn: () => graphqlClient.request(TemplateFieldssDocument, variables),
  });
};

export const requestTemplateFields = (params?: ListQueryVariables<Record<string, unknown>>) => {
  const variables = toScalarListVariables(params, { screenId: 'ScreenId' });
  return graphqlClient.request(TemplateFieldssDocument, variables);
};

export const GET_TEMPLATE_FIELDS_QUERY = TemplateFieldssDocument;
